const isValidGalleryId = (nodeId) => /^[-_\w]*$/.test(nodeId);
export {
  isValidGalleryId
};
//# sourceMappingURL=is-valid-gallery-id.js.map
